import gql from 'graphql-tag';

export const deleteMonLog = gql`
  mutation deleteMonLog($id: String) {
    deleteMonLog(id: $id) {
      value
    }
  }
`;
